<template>
  <svg class="icon arrow-extralong" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 12">
    <path d="M0 6h48m0 0-5-5m5 5-5 5" stroke="#162F47"/>
  </svg>
</template>
